import { render, staticRenderFns } from "./printers.vue?vue&type=template&id=99c5c06e&scoped=true&"
import script from "./printers.vue?vue&type=script&lang=js&"
export * from "./printers.vue?vue&type=script&lang=js&"
import style0 from "./printers.vue?vue&type=style&index=0&id=99c5c06e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c5c06e",
  null
  
)

export default component.exports